import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { cn } from "@/lib/utils"
import SelectSvg from "@/novus/assets/images/select.svg"
import * as React from "react"
import { OptionType } from "."

export function Combobox({
  value,
  options = [],
  onChange,
  placeholder,
  disabled,
}: {
  value: string
  options: OptionType[]
  onChange: (e: any) => void
  placeholder?: string
  disabled?: boolean
}) {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            role="combobox"
            aria-expanded={open}
            className={cn(
              "flex items-center justify-between gap-4 w-full rounded-md border border-input bg-background px-3 py-3 text-base ring-offset-background",
              "md:px-6 md:py-5 md:text-lg",
              value ? "text-neutral-900" : "text-neutral-400",
              {
                "pointer-events-none opacity-50": disabled,
              },
            )}
          >
            <div className="text-left">
              {value
                ? options.find((option) => option.value === value)?.label
                : placeholder || "Select..."}
            </div>
            <img src={SelectSvg} alt="Select" className="" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="flex flex-1 p-0">
          <Command>
            <CommandInput placeholder="Search..." className="h-9" />
            <CommandEmpty>No results found.</CommandEmpty>
            <CommandList>
              <CommandGroup>
                {options.map((option) => {
                  return (
                    <CommandItem
                      key={option.value}
                      value={option.value}
                      keywords={[option.label]}
                      onSelect={(currentValue) => {
                        onChange(currentValue === value ? "" : currentValue)
                        setOpen(false)
                      }}
                    >
                      {option.label}
                    </CommandItem>
                  )
                })}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </>
  )
}
